export const LOCAL_STORAGE_TOKEN_NAME = 'booking_access_token';

export const BOOKING_STATUSES = {
    SUCCESS: 'Success',
    CREDIT_CARD_REQUIRED: 'CreditCardRequired',
    PAYMENT_REQUIRED: 'PaymentRequired',
    AUTHENTICATION_REQUIRED: 'StripeAuthenticationRequired',
    NO_AVAILABILITY: 'NoAvailability',
    INVALID_PROMOTION: 'InvalidPromotion',
    INVALID_BOOKING: 'InvalidBooking',
    INVALID_BOOKING_REASON: 'InvalidBookingReason',
    LEAVE_TIME_CONFIRMATION_REQUIRED: 'LeaveTimeConfirmationRequired',
    PAYMENT_FAILED: 'PaymentFailed',
    BOOKING_NOT_FOUND: 'BookingNotFound',
}

export const isBookingStatusFatalError = (status, translations) => {
    switch(status) {
        case BOOKING_STATUSES.NO_AVAILABILITY: return { error: true, message: translations.label_error_booking_availability }
        case BOOKING_STATUSES.INVALID_PROMOTION: return { error: true, message: translations.label_error_creation_booking }
        case BOOKING_STATUSES.INVALID_BOOKING: return { error: true, message: translations.label_error_creation_booking }
        case BOOKING_STATUSES.INVALID_BOOKING_REASON: return { error: true, message: translations.label_error_creation_booking }
        case BOOKING_STATUSES.LEAVE_TIME_CONFIRMATION_REQUIRED: return { error: true, message: translations.label_error_creation_booking }
        case BOOKING_STATUSES.PAYMENT_FAILED: return { error: true, message: translations.label_payment_error }
        case BOOKING_STATUSES.BOOKING_NOT_FOUND: return { error: true, message: translations.label_error_update_booking }
        default: return { error: false, message: '' }
    }
};

export const BOOKING_CONFIRMATION_STEPS = {
    NO_CREDIT_CARD: 0,
    PAYMENT_REQUIRED: 1,
    CREDIT_CARD_REQUIRED: 2,
    SUCCESS: 10,
    ERROR: 11,
}

export const BOOKING_STEPS = {
    STORE: 0,
    PEOPLE: 1,
    DATE_TIME: 2,
    PROMOTION: 3,
    PERSONAL_DATA: 4,
}

export const LOGO_LOADER_SIZE = {
    SMALL: '100px',
    MEDIUM: '200px',
}

export const EDIT_BOOKING_STEPS = {
    SEARCH_BOOKING: 'SEARCH_BOOKING',
    SHOW_BOOKING: 'SHOW_BOOKING',
}

export const STEP_TITLES = {
    [BOOKING_STEPS.STORE]: 'Scegli un locale',
    [BOOKING_STEPS.PEOPLE]: 'Quanti siete?',
    [BOOKING_STEPS.DATE_TIME]: 'Scegli il giorno e ora',
    [BOOKING_STEPS.PROMOTION]: 'Scegli il menu',
    [BOOKING_STEPS.PERSONAL_DATA]: 'Inserisci i tuoi dati'
}

export const DEFAULT_COUNTRY_DATA = {
    name: "Italy (Italia)",
    iso2: "it",
    dialCode: "39",
    priority: 0,
    areaCodes: null,
}

export const ROUTES = {
    countries: '/',
    people: '/persone',
    date: '/giorno-ora',
    menu: '/menu',
    personalData: '/dati-personali',
    changeBooking: '/modifica-prenotazione',
    deleteBooking: '/cancella-prenotazione'
}

export const ROUTES_NO_HEADER = [ROUTES.changeBooking, ROUTES.deleteBooking];


// WEBPACK FOOTER //
// ./src/constants.js